export default async function* makeStreamLineIterator(stream) {
	const utf8Decoder = new TextDecoder("utf-8");
	let reader = stream.getReader();
	let {value: chunk, done: readerDone} = await reader.read();
	chunk = chunk ? utf8Decoder.decode(chunk, {stream: true}) : "";

	let re = /\r\n|\n|\r/gm;
	let startIndex = 0;

	for (;;) {
		let result = re.exec(chunk);
		if (!result) {
			if (readerDone) {
				break;
			}
			let remainder = chunk.substr(startIndex);
			({value: chunk, done: readerDone} = await reader.read());
			chunk = remainder + (chunk ? utf8Decoder.decode(chunk, {stream: true}) : "");
			startIndex = re.lastIndex = 0;
			continue;
		}
		yield chunk.substring(startIndex, result.index);
		startIndex = re.lastIndex;
	}
	if (startIndex < chunk.length) {
		// last line didn't end in a newline char
		yield chunk.substr(startIndex);
	}
}